export const GetCustomRolesApi = Symbol.for('GetCustomRolesApi');
